


























import { Component, Vue } from "vue-property-decorator";
import Maze from "./components/Maze.vue";

type Difficulty = "easy" | "normal" | "hard";

type Strategy = "cluster" | "dig";

@Component({
  components: {
    Maze
  }
})
export default class App extends Vue {
  mazeStyle = {
    width: "100%",
    height: "100%"
  };
  startTime = 0;
  time = 0;
  difficulty: Difficulty = "normal";
  strategy: Strategy = "cluster";
  onStart() {
    this.startTime = Date.now();
  }
  onFinish() {
    this.time = Date.now() - this.startTime;
  }
  onInit() {
    this.startTime = 0;
  }
}
